import InvoiceOilMain from "../InvoiceOil/InvoiceOilMain";
import MainInvoiceClass from "./MainInvoiceClass";
import InvoiceRestClass from "../InvoiceRest/InvoiceRestClass";

export default function InvoicesScreen(props) {
  const { AutoOptions, isPurches, isStock, isMake, isDialog, invtype, Prctype,
    isOrder,
    orderProceId,
    orderId, post,
  } = props;

    if (Prctype === "02") {
      if ((AutoOptions?.permType?.id === 3 || AutoOptions?.permType?.id === 7) && Prctype === "02") {
        return <InvoiceRestClass
          {...{
            AutoOptions,
            isPurches,
            isStock,
            isMake,
            isDialog,
            fromInv: true,
          }}
        />;
      }
      else if (AutoOptions?.permType?.id === 4 ||
        AutoOptions?.permType?.id === 5 && Prctype === "02") {
        return (
          <>
            <InvoiceOilMain
              {...{
                AutoOptions,
                isPurches: invtype == 3 || invtype == 4 || invtype == 6 ? true : false,
                isStock: invtype == 5 || invtype == 7 ? true : false,
                isMake: invtype == 7 ? false : false,
                isDialog: false,
              }}
            />

          </>

        );
      }
      else {
        return <MainInvoiceClass
          {...{
            AutoOptions,
            isPurches,
            isStock,
            isMake,
            isDialog,
            invtype,
            isOrder: isOrder,
            orderProceId: orderProceId,
            orderId: orderId,
          }}
        />;
      }
    } else {
      return <MainInvoiceClass
        {...{
          AutoOptions,
          isPurches,
          isStock,
          isMake,
          isDialog,
          invtype,
          isOrder: isOrder,
          orderProceId: orderProceId,
          orderId: orderId, post
        }}
      />;
    }
  
}
